<template>
  <form-submitter is_preview="true" />
</template>

<script>
  import Parse from "@/main.js"
  import FormSubmitter from "./FormSubmitter.vue"
  export default {
    components: {
      FormSubmitter
    },
  };
</script>